export enum DocumentTemplateRouteName {
    Index = 'document-templates.index',
    Create = 'document-templates.create',
    Edit = 'document-templates.edit',
}

export default {
    path: 'document-templates',
    name: DocumentTemplateRouteName.Index,
    component: () => import('./pages/index.vue'),
    meta: {
        label: 'Document Templates',
        icon: 'fal fa-file fa-fw',
        location: 'sidebar',
        permission: 'manage-document-templates',
        auth: true,
        group: 'main',
    },
    children: [
        {
            path: 'create',
            name: DocumentTemplateRouteName.Create,
            component: () => import('./pages/index.vue'),
            meta: {
                auth: true,
                label: 'Create Document Template',
                permission: 'manage-document-templates',
                group: 'main',
            },
        },
        {
            path: ':documentTemplateId/edit',
            name: DocumentTemplateRouteName.Edit,
            component: () => import('./pages/index.vue'),
            meta: {
                auth: true,
                label: 'Edit Document Template',
                permission: 'manage-document-templates',
                group: 'main',
            },
        },
    ],
}
